export default __webpack_public_path__ + "static/media/Mask567x567.f4339135.jpg";